export class VideoOverlay extends HTMLElement {
    constructor() {
        super();

        this._selectors = {
            video: "[js-video]",
            button: "[js-video-play]",
        };
    }

    connectedCallback() {
        this.button = this.querySelector(this._selectors.button);
        this.video = this.querySelector(this._selectors.video);
        this.button.addEventListener("click", this._playVideo);
    }

    _playVideo = () => {
        this.button.classList.add("hidden");
        this.video.setAttribute("controls", "controls");
        this.video.play();
    };
}
